// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge__badge___7Hp7f"};